import './bleed-image-text.scss';
    
/**
 * Section: Block Bleed Image Text
 * ------------------------------------------------------------------------------
 * Configured section to display a background video with text overlay.
 * - https://github.com/Shopify/theme-scripts/tree/master/packages/theme-sections.
 *
 * @namespace blockBleedImageText
 */

import {register} from '@shopify/theme-sections';

/**
 * Register the `video-hero` section type.
 */
register('block-bleed-image-text', {

  /**
 * Set cached node selectors.
 */
  setNodeSelectors() {
    this.container = document.querySelector(`#Block-bleed-image-text-${this.id}`);
  },

  /**
 * Instantiate events on video player.
 */
  init() {
    this.setNodeSelectors();
  },

  /**
 * Callback function when section is loaded via `sections.load()` or
 * by the Theme Editor `shopify:section:load` event.
 */
  onLoad() {
    this.init();
  },
});
